// extracted by mini-css-extract-plugin
export default {"citation":"citation__EypQeZ","citationPopover":"citationPopover__UmS2Ph","icon":"icon__zCceeO","iconNotCited":"iconNotCited__EA07qc"};